module.exports = __webpack_public_path__ + "static/media/richmondDrink.876db47b.pdf";